import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { PaginationContext, ListWithPagination } from 'dash-ui';
import { useGetPortfoliosWithReactionsQuery } from 'gql/generated.graphql';

import PortfolioWithReactionCard from './components/PortfolioWithReactionCard/PortfolioWithReactionCard';

const StyledList = styled(ListWithPagination)`
  & > div:first-child {
    padding: 0;
    border: none;
  }
  & > div:last-child {
    justify-content: center;
  }
`;

const ReactionByPortfoliosView = () => {
  const { t } = useTranslation(['common', 'pages']);
  const { setTotal, state, getRefetchProps, setPerPage } =
    useContext(PaginationContext);
  const pagination = getRefetchProps(state);

  const { data, loading } = useGetPortfoliosWithReactionsQuery({
    variables: {
      pagination,
    },
  });

  const { portfolios, totalCount } = useMemo(
    () => ({
      portfolios: data?.getPortfoliosWithReactions.collection || [],
      totalCount: data?.getPortfoliosWithReactions.totalCount || 0,
    }),
    [data]
  );

  useEffect(() => {
    setTotal(totalCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCount]);

  useEffect(() => {
    setPerPage(12);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledList
      paginationProps={{
        nextButtonLabel: t('common:labels.next'),
        previousButtonLabel: t('common:labels.previous'),
      }}
      listProps={{
        w: '100%',
        loading,
        loadingProps: { bgColor: 'inherit' },
        grid: ['1fr', 251, 251, 251],
        data: portfolios,
        gap: 16,
        mb: 2,
        mt: 4,
      }}
    >
      {(item) => <PortfolioWithReactionCard portfolio={item} />}
    </StyledList>
  );
};

export default ReactionByPortfoliosView;
